import { bindActionCreators } from 'redux'
import {
  fetchInitialDsrData,
  getDsrFeedContent,
  resetDsrFeedContent,
  resetDsrPages,
  resetDsrSelectedDisplaySubpage,
  setShowDsrModal,
  setUserActionRequired,
  updateDsrReset,
  updateDsr
} from '../actions/dsr-actions'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import DsrViewArchivedPage from './DsrViewArchivedPage'

const DsrViewArchivedContainer = (props) => {
  return <DsrViewArchivedPage {...props} />
}

const mapStateToProps = (state) => ({
  dsrConfiguration: state.dsrConfiguration.results.data,
  dsrFeedContent: state.dsrFeedContent.results,
  currentDsrId: state.dsrFeedContent.id,
  dsrPagesRedux: state.setDsrPages.pages,
  dsrInvalidRequestRedux: state.dsrInvalidRequest.request,
  dsrTeamMembersRedux: state.dsrTeamMembers.members,
  showDsrModalRedux: state.dsrModal.showDsrModal,
  userActionRequiredRedux: state.dsrPopup.UserActionRequired,
  dsrTitle: state.dsrTitle.title,
  showDsrModalLoaderRedux: state.showDsrModalLoader.show,
  selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
  isMobileView: state.mobileViewMode.isMobileView,
  isLockedRoom :state.lockedRoomCheck.isLockedRoom,
  lockedRoomMetadata: state.lockedRoomMetadata.results,
  hideOptionForInvalidLink: state.hideOptionForInvalidLink.isHideOptionsForInvalidLink,
  isArchivedDsr: state.isArchivedDsr.results,
  isShrunkHeader: state.shrunkHeaderView.isShrunkHeader,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDsrFeedContent,
      setShowDsrModal,
      setUserActionRequired,
      fetchInitialDsrData,
      resetDsrFeedContent,
      resetDsrSelectedDisplaySubpage,
      resetDsrPages,
      updateDsr,
      updateDsrReset
    },
    dispatch,
  )

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DsrViewArchivedContainer),
)
